import React from 'react';
import { motion } from 'framer-motion';
import { MoreHorizontal, AlertTriangle, Eye, Flag } from 'lucide-react';
import { Badge } from './Badge';
import { Button } from './Button';
import { Vehicle } from '../../utils/mockData';
import { format } from 'date-fns';
interface EventCardProps {
  vehicle: Vehicle;
  onClick: (vehicle: Vehicle) => void;
}
export function EventCard({
  vehicle,
  onClick
}: EventCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="group relative flex gap-4 rounded-lg border border-gray-800 bg-[#1a1d23] p-4 transition-all hover:border-gray-700 hover:bg-[#20242c]" data-id="element-369">
      {/* Thumbnail */}
      <div className="relative h-20 w-20 flex-shrink-0 overflow-hidden rounded-md bg-gray-900 border border-gray-800" data-id="element-370">
        <img src={vehicle.thumbnailUrl} alt="Vehicle" className="h-full w-full object-cover opacity-80 transition-opacity group-hover:opacity-100" data-id="element-371" />
        <div className="absolute bottom-0 left-0 right-0 bg-black/60 px-1 py-0.5 text-center text-[10px] text-gray-300" data-id="element-372">
          {vehicle.confidence}% Conf.
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-1 flex-col justify-between" data-id="element-373">
        <div className="flex items-start justify-between" data-id="element-374">
          <div data-id="element-375">
            <div className="flex items-center gap-2" data-id="element-376">
              <h4 onClick={() => onClick(vehicle)} className="cursor-pointer text-lg font-bold text-white hover:text-amber-500 hover:underline" data-id="element-377">
                {vehicle.plate}
              </h4>
              <Badge variant="neutral" className="text-[10px]" data-id="element-378">
                {vehicle.type}
              </Badge>
              {vehicle.hasWarning && <div className="flex items-center text-amber-500" title={vehicle.warningReason} data-id="element-379">
                  <AlertTriangle className="h-4 w-4" data-id="element-380" />
                </div>}
            </div>
            <div className="mt-1 flex items-center gap-2 text-xs text-gray-400" data-id="element-381">
              <span data-id="element-382">{vehicle.gate}</span>
              <span data-id="element-383">•</span>
              <span data-id="element-384">{format(vehicle.entryTime, 'HH:mm:ss')}</span>
              <span data-id="element-385">•</span>
              <span data-id="element-386">Visits ({vehicle.visitCount})</span>
            </div>
          </div>

          <div className="flex gap-1 opacity-0 transition-opacity group-hover:opacity-100" data-id="element-387">
            <Button size="icon" variant="ghost" className="h-8 w-8" title="View History" onClick={() => onClick(vehicle)} data-id="element-388">
              <Eye className="h-4 w-4" data-id="element-389" />
            </Button>
            <Button size="icon" variant="ghost" className="h-8 w-8" title="Add Warning" data-id="element-390">
              <Flag className="h-4 w-4" data-id="element-391" />
            </Button>
          </div>
        </div>
      </div>
    </motion.div>;
}